import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { SetTableFilterValue, ToggleTableFilterVisibility } from './table-filter.actions';
import { TableFilterStateModel, TranslationType } from 'src/app/model';

@State<TableFilterStateModel>({
  name: 'tableFilter',
  defaults: {
    isTableFilterVisible: false,
    tableFilterValue: {},
  },
})
@Injectable()
export class TableFilterState {
  @Selector()
  static isTableFilterVisible(state: TableFilterStateModel): boolean {
    return state.isTableFilterVisible;
  }

  @Selector()
  static tableFilterValue(state: TableFilterStateModel): TranslationType {
    return state.tableFilterValue;
  }

  @Action(ToggleTableFilterVisibility)
  toggleTableFilterVisibility({ getState, patchState }: StateContext<TableFilterStateModel>): void {
    patchState({
      ...getState(),
      isTableFilterVisible: !getState().isTableFilterVisible,
    });
  }

  @Action(SetTableFilterValue)
  setTableFilterValue({ getState, patchState }: StateContext<TableFilterStateModel>, { payload }: { payload: TranslationType }): void {
    patchState({
      ...getState(),
      tableFilterValue: payload,
    });
  }
}
